import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  getDatasource,
  createTable,
  createCollection,
} from 'ducks/apps/datasources'
import { getCurrentOrganizationId } from 'ducks/organizations'

import { trackCreatedCollection } from 'utils/funnelTracking'

import history from '../../../history'

import Icon from '../../Shared/Icon'

class CreateTable extends Component {
  handleClick = () => {
    const {
      createTable,
      createCollection,
      appId,
      datasourceId,
      datasource,
      currentOrganizationId,
    } = this.props

    const name = window.prompt(`Enter ${this.getName()} Name (i.e. Users)`)

    if (!name) {
      return
    }

    let id

    if (datasource.type === 'api') {
      id = createCollection(appId, datasourceId, name).id

      if (currentOrganizationId) {
        trackCreatedCollection(currentOrganizationId).catch(error => {
          console.error('Failed to track collection creation:', error)
        })
      }
    } else {
      id = createTable(appId, datasourceId, name).id
    }

    const url = `/apps/${appId}/data/${datasourceId}/${id}`

    history.replace(url)
  }

  getName() {
    const { datasource } = this.props

    if (datasource.type === 'api') {
      return 'Collection'
    } else {
      return 'Table'
    }
  }

  render() {
    const { datasourceId, datasource } = this.props

    if (!datasourceId || !datasource) {
      return null
    }

    return (
      <p className="create-table-link">
        <a className="deemphasize" onClick={this.handleClick}>
          <Icon type="plus" />
          Add {this.getName()}
        </a>
      </p>
    )
  }
}

const mapStateToProps = (state, { appId, datasourceId }) => ({
  datasource: getDatasource(state, appId, datasourceId),
  currentOrganizationId: getCurrentOrganizationId(state),
})

export default connect(mapStateToProps, { createTable, createCollection })(
  CreateTable
)
